module.exports = __webpack_public_path__ + "img/enterprise_manage.9051253a.svg";